import api from "../utils/api";

class RouteSegmentsApi {
  getAll = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get("/route-segments", { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  create = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post("/route-segments", data);

        resolve(res.data);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  };

  create_multiple = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post("/rates/add-price", data);

        resolve(res.data);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  };

  deleteMultipleRate = (data) => {
    return new Promise((resolve, reject) => {
      return api
        .post(`/rates/delete-price`, data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  update = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/route-segments/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  delete = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.delete(`/route-segments/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getDetail = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/route-segments/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  updateStatus = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/route-segments/status/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  copy = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/route-segments/copy/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  updateMultipleStatus = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post("/rates/update-multiple-status", data);

        resolve(res.data);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  };

  updateStatusRates = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post("/rates/update-status", data);

        resolve(res.data);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  };
}
const routeSegmentsApi = new RouteSegmentsApi();
export default routeSegmentsApi;
